import ActionButton from '@/common/components/buttons/ActionButton';
import Loading from '@/common/components/Loading';
import Table from '@/common/components/Table';
import { PageWrapper } from '@/common/styles/Wrappers';
import AddAccountForm from './components/AddAccountForm';
import MetaAccountForm from './components/MetaAccountForm/MetaAccountForm';
import {
	ADD_ACCOUNTS_TABLE_HEADERS,
	META_ACCOUNTS_TABLE_HEADERS,
} from './constants/tableHeaders';
import {
	getAddAccountTableRows,
	getMetaAccountTableRows,
} from './helpers/getTableRows';
import useMetaAccountsList from './hooks/useMetaAccountsList';
import SyncLeadCostsForm from './components/SyncLeadCostsForm';

const MetaAccountsList = () => {
	const hook = useMetaAccountsList();

	return (
		<PageWrapper>
			{hook.isLoading && <Loading />}
			<ActionButton
				style={{ height: 'fit-content' }}
				onClick={() => hook.setSelectedMetaAccountForm({})}
				defaultText='Create Meta Account'
			/>
			<Table
				className='styled-table'
				raws={getMetaAccountTableRows(
					hook.accounts,
					hook.setSelectedMetaAccountForm,
					hook.setShowSyncPopup,
				)}
				headers={META_ACCOUNTS_TABLE_HEADERS}
			/>

			<ActionButton
				style={{ height: 'fit-content' }}
				onClick={() => hook.setSelectedAddAccountForm({})}
				defaultText='Create Add Account'
			/>
			<Table
				className='styled-table'
				raws={getAddAccountTableRows(
					hook.accounts,
					hook.setSelectedAddAccountForm,
				)}
				headers={ADD_ACCOUNTS_TABLE_HEADERS}
			/>

			{hook.selectedMetaAccountForm && (
				<MetaAccountForm
					setShow={hook.setSelectedMetaAccountForm}
					account={hook.selectedMetaAccountForm}
				/>
			)}
			{hook.selectedAddAccountForm && (
				<AddAccountForm
					setShow={hook.setSelectedAddAccountForm}
					account={hook.selectedAddAccountForm}
					metaAccounts={hook.accounts}
				/>
			)}
			{hook.showSyncPopup && (
				<SyncLeadCostsForm
					setShow={hook.setShowSyncPopup}
					account={hook.showSyncPopup}
				/>
			)}
		</PageWrapper>
	);
};

export default MetaAccountsList;
